/**
 * Created by chenmf on 2017/6/21.
 */
import * as types from './mutation-types';
import {getStorage} from '../api/storage';
import {getApi, postApi} from "../api/commonApi";
import {mapState, mapGetters} from 'vuex';

export const loginInfo = ({
                            commit
                          }, userId) => {
  let that = this;
  getApi('/txCloud/user/getPortrait', {
    userId: userId
  }, function (data) {
    that.loginUser = data.user
    commit(types.SET_USER, {
      user: data.user
    });
  }, function (data) {
  });
};

export const initSessions = ({
                               commit
                             }, fun) => {
  let that = this
  getApi("txCloud/friend/list", {
    userId: localStorage.getItem("userId"),
    page: 1,
    limit: 15
  }, function (data) {
    let list = data.friendList;
//		fun(list)
    //存放好友信息的map  头像和名称 用于
    var infoMap = {};
    var pattern = /^[0-9]*$/;
    for (let i in list) {
      var friend = list[i];
      let toUid = friend.toUid;//好友id
      if (pattern.test(toUid)) {
        let image = friend.image;//好友头像
        let name = friend.name;//好友名称
        infoMap[toUid] = {
          name: name,
          image: image
        }
      }
    }
    commit(types.SET_INFO_MAP, {
      infoMap: infoMap
    });
    commit(types.SET_SESSIONS, {
      sessions: list
    });
    commit(types.SET_FILTER_KEY, {
      id: list[0].toUid
    });
  }, function (data) {
  });
};

//export const sendMessage = ({commit}, {content, self = true}) => {
//	commit(types.SEND_MESSAGE, {content, self});
//};

export const setSessions = ({
                              commit
                            }, sessions) => {
  commit(types.SET_SESSIONS, {
    sessions
  });
};

export const sendMessage = ({
                              commit
                            }, msgInfo) => {
  postApi('txCloud/message/send', msgInfo, function (data) {
    var message = {
      content: msgInfo.msg,
      time: new Date(),
      self: true
    }
  }, function (data) {
  });
};

export const setMessages = ({
                              commit
                            }, messages) => {
  commit(types.SET_MESSAGES, {
    messages
  });
};

export const setMsgMap = ({
                            commit
                          }, msgMap) => {
  commit(types.SET_MSGMAP, {
    msgMap
  });
};

export const setPrePageInfo = ({
                                 commit
                               }, prePageInfo) => {
  commit(types.SET_PREPAGE_INFO, {
    prePageInfo
  });
};

export const selectSession = ({
                                commit
                              }, id) => {
  commit(types.SELECT_SESSION, {
    id
  });
};

export const setFilterKey = ({
                               commit
                             }, key) => {
  key = key.toLocaleLowerCase();
  commit(types.SET_FILTER_KEY, {
    key
  });
};

export const setLogo = ({
                          commit
                        }, key) => {
  commit('setLogo', key);
};

export const setColors = ({
                            commit
                          }, key) => {
  commit('setColors', key);
};

export const setDetail = ({
                            commit
                          }, key) => {
  commit('setDetail', key);
};
//任务详情信息
export const setTaskInfo = ({
                              commit
                            }, key) => {
  commit('setTaskInfo', key);
};



// WEBPACK FOOTER //
// ./src/store/actions.js